import type { AuthError } from '@supabase/supabase-js';

/**
 * Maps raw Supabase auth errors to user-friendly copy.
 * Full error is still logged via console.error at the call site — this
 * function only controls what's rendered on the page.
 */
export function friendlyAuthError(err: AuthError): string {
  const msg = err.message.toLowerCase();

  if (msg.includes('invalid login credentials')) {
    return 'Invalid email or password.';
  }
  if (msg.includes('email not confirmed')) {
    return 'Please confirm your email address, then sign in.';
  }
  if (msg.includes('user already registered')) {
    return 'An account with that email already exists. Try signing in instead.';
  }
  if (msg.includes('rate limit') || msg.includes('too many')) {
    return 'Too many attempts. Please wait a moment and try again.';
  }
  if (msg.includes('network') || msg.includes('fetch')) {
    return "Can't reach the server. Check your connection and try again.";
  }
  if (msg.includes('password') && msg.includes('characters')) {
    return 'Password must be at least 6 characters.';
  }

  return 'Something went wrong. Please try again.';
}
